import { useMemo } from "react";
import { Img } from "react-image";

import { TalkMessageDocumentImage } from "../../models/TalkMessageDocument";
import styles from "./TalkMessageImage.module.css";

const containerWidth = 192;
const containerHeight = 254;

export type TalkMessageImageProps = {
  image: TalkMessageDocumentImage;
};

export const TalkMessageImage = ({ image }: TalkMessageImageProps) => {
  const { width, height } = useMemo(() => {
    const imageRatio = image.width / image.height;
    const containerRatio = containerWidth / containerHeight;

    // img の width / height 属性は整数のみ有効なため丸める
    if (imageRatio > containerRatio) {
      return {
        width: containerWidth,
        height: Math.round(containerWidth / imageRatio),
      };
    }

    return {
      width: Math.round(containerHeight * imageRatio),
      height: containerHeight,
    };
  }, [image.height, image.width]);

  return (
    <div style={{ minHeight: height, minWidth: width }}>
      <Img src={image.url} alt={image.name} className={styles.image} width={width} height={height} />
    </div>
  );
};
